"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var PinOffOutline = function PinOffOutline(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10352 2.0791L2.07812 2.10547L21.873 21.9004L20.4746 23.2998L14.457 17.2822V18.5645L13.1035 19.918L9.2998 16.1152L4.0625 21.3516H2.64844V19.9375L7.88477 14.7012L4.08105 10.8994L5.43555 9.5459H6.7207L0.674805 3.5L2.09961 2.0752L2.10352 2.0791ZM12.457 16.4434V15.2822L8.7207 11.5459H7.55762L12.457 16.4434Z",
    fill: "currentColor"
  }), (0, _preact.h)("path", {
    d: "M22.041 9.56836L20.627 10.9824L19.9189 10.2754L16.5068 13.6846L15.0928 12.2705L18.5049 8.86133L15.1416 5.5L11.7314 8.9082L10.3164 7.49316L13.7266 4.08594L13.0195 3.37793L14.4346 1.96387L22.041 9.56836Z",
    fill: "currentColor"
  }));
};

var _default = PinOffOutline;
exports.default = _default;